var map = {
	"./NoImage.jpg": "151d",
	"./agriportal-logo-v2.png": "62d1",
	"./agriportal-logo.png": "ac0e",
	"./auth-bg-2.jpg": "d03c",
	"./auth-bg-3.jpg": "1d21",
	"./business-logo-default.png": "20c9",
	"./cart.png": "41b9",
	"./current_pos.png": "1cfa",
	"./dac-san-chan-nuoi-logo.jpg": "f4a8",
	"./dac-san-logo.jpg": "bf2c",
	"./hoi-dap-nong-nghiep.jpg": "ab53",
	"./home.png": "fbf5",
	"./home/default.png": "47dd",
	"./home/icon_v2/CallCenter.png": "659e",
	"./home/icon_v2/Connect.png": "2b5d",
	"./home/icon_v2/Contact.png": "a6e5",
	"./home/icon_v2/Download.png": "70f6d",
	"./home/icon_v2/Environment.png": "abd9",
	"./home/icon_v2/Fap.png": "492c",
	"./home/icon_v2/Map.png": "b952",
	"./home/icon_v2/MarketPrice.png": "63cd",
	"./home/icon_v2/Product.png": "a617",
	"./home/icon_v2/ProductChain.png": "d72b",
	"./home/icon_v2/View.png": "aa1b",
	"./home/quan_trac.jpeg": "c5b9",
	"./home/san_pham_nn.jpg": "bd43",
	"./home/thi_truong.jpg": "1493",
	"./home/tong_dai.png": "dbff",
	"./home/truy_xuat.jpg": "7e83",
	"./logo-VNPT.png": "bfcd",
	"./logo.png": "cf05",
	"./marker.png": "3b84",
	"./market/thumb3.png": "2b03",
	"./news-default-thumb.jpeg": "e15a",
	"./ocop-logo.png": "0179",
	"./sidebar-bg.jpg": "30cb",
	"./sidebar-border.png": "8d54",
	"./simple-marker.png": "a2b8",
	"./slides/default.png": "69fd",
	"./states/tgg-states": "9896",
	"./states/tgg-states.json": "9896",
	"./support.png": "c042",
	"./tglogo.png": "4a1e",
	"./user-default.jpg": "6c4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";